module.exports = {"411625001":"洺南","411625002":"洺北","411625003":"新城","411625101":"吴台镇","411625102":"南丰镇","411625103":"白马镇","411625104":"宁平镇","411625105":"宜路镇","411625106":"钱店镇","411625107":"汲冢镇","411625108":"石槽镇","411625200":"城郊乡","411625201":"虎头岗乡","411625202":"汲水乡","411625203":"张完集乡","411625204":"丁村乡","411625205":"双楼乡","411625206":"秋渠乡","411625207":"东风乡","411625208":"巴集乡","411625209":"李楼乡","411625210":"胡集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411625.json
// module id = 1533
// module chunks = 0